module.exports = __webpack_public_path__ + "img/instruction-ios-01.e28c8dc6.png";